<template>
  <PageWrap page-title="Usuarios">
    <b-row>
      <b-col md="6">
        <BfInput
          v-model="searchTermName"
          data-key="searchTermName"
          placeholder="Buscar por nombre"
          suffix-icon="el-icon-search"
          @update="updateSearch"
        />
      </b-col>
      <b-col md="6">
        <BfInput
          v-model="searchTermCode"
          data-key="searchTermCode"
          placeholder="Buscar por clave"
          suffix-icon="el-icon-search"
          @update="updateSearch"
        />
      </b-col>
    </b-row>

    <LoadingIndicator v-if="loadingData" />

    <BfTable
      v-else
      :data="tasadores"
      :columns="tableColumns"
                      cell-class-name="tasaciones-small-cell"

      border
      @row-click="tableRowClick"
      @sort-change="updateTableSorting"
    >
      <span slot="clave" slot-scope="{row}" class="tasaciones-table-marker">
        {{row.clave}}
      </span>

      <template slot="oficial" slot-scope="{row}">
        {{row.oficial ? 'Sí' : 'No'}}
      </template>

      <template slot="activo" slot-scope="{row}">
        {{row.activo ? 'Sí' : 'No'}}
      </template>
    </BfTable>

    <b-row class="mt-5">
      <b-col>
        <BfButton :to="{name: 'tasador'}" tag="router-link">Nuevo Usuario</BfButton>
      </b-col>
      <b-col class="text-right">
        <BfPagination
          v-if="tasadores.length"
          :current-page="currentPage"
          :total="totalRows"
          :page-size="perPage"
          @current-change="updatePagination"
        />
      </b-col>
    </b-row>
  </PageWrap>
</template>

<script>
/* eslint-disable object-curly-newline */
import PageWrap from '@/components/PageWrap';
import LoadingIndicator from '@/components/LoadingIndicator';
import router from '@/router';
import { assessorAPI } from '@/api';

export default {
  name: 'AssessorsList',

  data() {
    return {
      charges: [],
      tasadores: [],
      currentPage: 1,
      dateFrom: '',
      dateTo: '',
      loadingData: false,
      perPage: 15,
      searchTermCode: '',
      searchTermName: '',
      sortBy: null,
      sortOrder: null,
      totalRows: 0,
    };
  },

  async created() {
    this.loadingData = true;
    try {
      this.loadData();
    } finally {
      this.loadingData = false;
    }
  },

  methods: {
    async loadData() {
      const {
        data: { data, current_page: currentPage, per_page: perPage, total },
      } = await assessorAPI.getAll({
        page: this.currentPage,
        perPage: this.perPage,
        searchCode: this.searchTermCode,
        searchName: this.searchTermName,
        sort: this.sortParameter,
        to: this.dateTo !== '' ? this.dateTo : undefined,
      });

      this.tasadores = data;
      this.totalRows = total;
      this.perPage = Number(perPage);
      this.currentPage = currentPage;
    },

    updateSearch() {
      this.loadData();
    },

    tableRowClick({ row, column }) {
      if (column.property === 'clave') {
        const { id } = row;
        router.push({ name: 'tasador', params: { id: `${id}` } });
      }
    },

    updatePagination(newPage) {
      if (newPage !== this.currentPage) {
        this.currentPage = newPage;

        this.loadData();
      }
    },

    updateTableSorting({ key, order }) {
      this.sortBy = key;
      this.sortOrder = order;

      this.loadData();
    },
  },

  computed: {
    sortParameter() {
      if (!this.sortBy && !this.sortOrder) {
        return '';
      }

      return `${this.sortOrder === 'ascending' ? '' : '-'}${this.sortBy}`;
    },

    tableColumns() {
      return [
        {
          label: 'Clave',
          dataKey: 'clave',
          sortable: 'custom',
          width: 150,
        },
        {
          label: 'Nombre',
          dataKey: 'nombre',
          sortable: 'custom',
          width: 400,
        },
        {
          label: 'Oficial',
          dataKey: 'oficial',
          sortable: 'custom',
        },
        {
          label: 'Activo',
          dataKey: 'activo',
          sortable: 'custom',
        },
        {
          label: 'Zona',
          dataKey: 'zona_nombre',
          sortable: 'custom',
        },
        {
          label: 'Usuario asociado',
          dataKey: 'usuario_acceso_nombre',
          sortable: 'custom',
        },
      ];
    },
  },

  components: {
    LoadingIndicator,
    PageWrap,
  },
};
</script>
